import { Box } from '@opendoor/atoms/box';
import { Button } from '@opendoor/atoms/button';

interface ShowMoreProps {
  onShowMore: () => void;
  isLoading: boolean;
}

export const ShowMore = ({ onShowMore, isLoading }: ShowMoreProps) => (
  <Box className="pt-6 pb-8">
    <Button
      analyticsName="more-property-list"
      aria-label="Show more"
      onClick={onShowMore}
      variant="secondary"
      loading={isLoading}
      className="w-full"
    >
      Show more
    </Button>
  </Box>
);
